export default __webpack_public_path__ + "static/media/bould.add79e95.png";